export const GOOGLE_OAUTH_PATH = '/users/auth/google_oauth2';

// Kill switch for the provider flow — flip and release.
export const IS_GOOGLE_AUTH_HIDDEN = false;

export enum AuthMissedField {
  Country = 'country',
  Terms = 'terms_acceptance',
}
